<template>
  <div class="info-page">
    <div class="content-card">
      <h2>🔐 隱私權政策 (Privacy Policy)</h2>
      <p class="last-updated">最後更新日期：2026年2月19日</p>
      
      <div class="policy-section">
        <h3>1. 資料收集</h3>
        <p>我們收集的資料可能包括：</p>
        <ul>
          <li><strong>帳戶資料：</strong> 如果您選擇使用 Google 或 Apple 帳號登入，我們將收集您的電子郵件地址及基本個人資料以進行雲端同步。</li>
          <li><strong>使用數據：</strong> 我們可能會收集有關您如何使用應用程式匿名數據，以改善我們的服務。</li>
        </ul>
      </div>

      <div class="policy-section">
        <h3>2. 資料用途</h3>
        <p>收集的資料主要用於：</p>
        <ul>
          <li>提供及維護我們的服務（例如：同步您的自訂規則）。</li>
          <li>改善應用程式的功能及使用者體驗。</li>
          <li>顯示個人化廣告（透過 AdMob）。</li>
        </ul>
      </div>

      <div class="policy-section">
        <h3>3. 廣告服務</h3>
        <p>本應用程式使用 Google AdMob 提供廣告。AdMob 可能會收集您的廣告識別碼以顯示相關廣告。詳情請參閱 <a href="https://policies.google.com/privacy" target="_blank">Google 隱私權政策</a>。</p>
      </div>

      <div class="policy-section">
        <h3>4. 資料安全</h3>
        <p>我們採取合理的安全措施來保護您的個人資料。然而，請注意，任何透過網路傳輸或電子儲存的方法都不是 100% 安全的。</p>
      </div>

      <div class="policy-section">
        <h3>5. 聯絡我們</h3>
        <p>如果您對本隱私權政策有任何疑問，請透過 <a href="mailto:mahjong@siuheibo.com">mahjong@siuheibo.com</a> 聯絡我們。</p>
      </div>

      <button class="back-link" @click="$router.back()">返回</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPage'
}
</script>

<style scoped>
.info-page {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.content-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
}

h2 {
  color: #2d3748;
  margin-top: 0;
  margin-bottom: 10px;
}

.last-updated {
  font-size: 0.85rem;
  color: #a0aec0;
  margin-bottom: 30px;
}

h3 {
  color: #4a5568;
  margin-top: 25px;
  font-size: 1.2rem;
}

p, li {
  line-height: 1.6;
  color: #4a5568;
  font-size: 0.95rem;
}

ul {
  padding-left: 20px;
}

li {
  margin-bottom: 8px;
}

a {
  color: #4CAF50;
  text-decoration: none;
  font-weight: 500;
}

a:hover {
  text-decoration: underline;
}

.back-link {
  margin-top: 30px;
  background: #f0f2f5;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  color: #4a5568;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s;
}

.back-link:hover {
  background: #e2e8f0;
}
</style>
